"use client";
import { Provider } from "react-redux";

import { store } from "@/lib/state/store";

export default function ReduxProvider({ children }: React.PropsWithChildren) {
  return <Provider store={store}>{children}</Provider>;
}
